import {
  AdminAccountWebService,
  AdminPartnerWebService,
  AdminNotificationWebService
} from '@linktivity/gds-neo';

export const ListAdminAccountsStatusEnum =
  AdminAccountWebService.ListAdminAccountsStatusEnum;

export const ListOtasTagTypesEnum = AdminPartnerWebService.ListOtasTagTypesEnum;

export const NotificationStatus =
  AdminNotificationWebService.NotificationStatus;
export type NotificationStatus = AdminNotificationWebService.NotificationStatus;

export const TargetType = AdminNotificationWebService.TargetType;
export type TargetType = AdminNotificationWebService.TargetType;

export const OrgType = AdminNotificationWebService.OrgType;
export type OrgType = AdminNotificationWebService.OrgType;

export type RoleTarget = AdminNotificationWebService.RoleTarget;

export const TargetEmailDomain = AdminNotificationWebService.TargetEmailDomain;
export type TargetEmailDomain = AdminNotificationWebService.TargetEmailDomain;

export const Language = AdminNotificationWebService.Language;
export type Language = AdminNotificationWebService.Language;
